import React from "react";

const SavedTab = () => {
    return <div>SavedTab</div>;
};

export default SavedTab;
